
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.738 17.111c-2.8-.051-3.756-.097-4.343-.219a1.91 1.91 0 01-.997-.518c-.196-.196-.351-.495-.472-.91-.104-.346-.144-.634-.202-1.336-.088-1.587-.109-2.883 0-4.332.09-.8.134-1.75.732-2.305.282-.26.61-.426.979-.495.576-.11 3.03-.196 5.57-.196 2.535 0 4.995.087 5.571.196.46.086.893.346 1.146.68.546.858.555 1.925.61 2.76.024.397.024 2.655 0 3.052-.085 1.32-.155 1.786-.35 2.27-.122.305-.225.466-.404.645-.28.275-.638.458-1.025.524a71.25 71.25 0 01-6.815.184zm3.71-5.3c-1.348-.72-2.638-1.387-3.958-2.079v4.136c1.389-.754 2.852-1.446 3.964-2.062l-.006.006z","fill":"red","fill-rule":"evenodd"}})])
          )
        }
      }
    